"use client";

import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const LanguageDropdown = ({ selectedCountry }) => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const LANGUAGE_LABELS = {
    en: "English",
    es: "Español",
    ar: "العربية",
    "ar-IQ": "العربية (العراق)",
    ckb: "کوردی (سۆرانی)",
    sdh: "کوردی (بادینی)",
  };
  useEffect(() => {
    const lang = Cookies.get("language") || "en";

    if (selectedCountry?.languages.includes(lang)) {
      setSelectedLanguage(lang);
    } else if (selectedCountry?.languages?.length) {
      setSelectedLanguage(selectedCountry.languages[0]);
    }
  }, [selectedCountry]);

  const handleChange = (e) => {
    const lang = e.target.value;
    setSelectedLanguage(lang);
    Cookies.set("language", lang, { expires: 365 });
    window.location.reload();
  };

  if (!selectedCountry || selectedCountry.languages.length <= 1) return null;

  return (
    <div className="language_select_wrapper">
      <select value={selectedLanguage} onChange={handleChange}>
        {selectedCountry.languages.map((lang) => (
          <option key={lang} value={lang}>
            {LANGUAGE_LABELS[lang] || lang}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageDropdown;
